import React from 'react';
import avatar from '../../../../../assets/uploads/teacher-avatar.jpg'
import avatar2 from '../../../../../assets/uploads/student-avatar.jpg'
import {useAppSelector} from "../../../../../common/hook";
import {REMAINING_PAID_LESSONS, ROLE_TEACHER, WELCOME_MESSAGE} from "../../../../../entities/constants/constants";
import {getProfileData} from "../../../../../entities/Profile/model/selectors/getProfileData/getProfileData";
import {getCabinetData} from "../../../../../entities/Cabiner/model/selectors/getCabinetData/getCabinetData";
import {Link} from "react-router-dom";


export const PersonalBox = () => {
    const roleType = useAppSelector((state) => state.role.roleType);
    const cabinetData = useAppSelector(getCabinetData)


    return (
        <div className="person-data-box">
            <div className="person-data-col">
                <div className="person-avatar-box">
                    <div className="person-avatar avatar">
                        <img src={cabinetData?.avatar} alt="avatar"/>
                    </div>
                </div>
                <div className="person-data">
                    <p className="h3 person-name">{WELCOME_MESSAGE}, {cabinetData?.fullName}</p>
                    {roleType === ROLE_TEACHER ?
                        <p className="sub-text">
                            Последнее обновление {cabinetData?.lastUpdateDate},&nbsp;{cabinetData?.lastUpdateTime}
                        </p>
                        :
                        <p>
                            {REMAINING_PAID_LESSONS} {cabinetData?.paidClasses != null && (
                            <Link style={{boxShadow: 'none'}} to={`/buy-course`}>
                                <span className="text-mark">
                                        {cabinetData.paidClasses}
                                </span>
                            </Link>
                        )}
                        </p>
                    }
                </div>
            </div>
        </div>
    );
};

